import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dialog-inner" }
const _hoisted_2 = { class: "dialog-content" }
const _hoisted_3 = { class: "dialog-content-main" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 2,
  class: "dialog-btns"
}
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dialog-wrapper", [_ctx.dialogData.type && 'dialog-' + _ctx.dialogData.type + '-wrapper']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.dialogData.text)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                innerHTML: _ctx.dialogData.text
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.dialogData.subText)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: "sub-text",
                innerHTML: _ctx.dialogData.subText
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.dialogData.btns)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogData.btns, (btn) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["dialog-btn", [btn.className]]),
                    onClick: ($event: any) => (_ctx.btnClick(btn))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(btn.text), 1)
                  ], 10, _hoisted_7))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}